export default __webpack_public_path__ + "static/media/icon-lock.7a31ac23.svg";